import type { ReactNode } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ensureRouteData } from '~/lib/query';
import { teamQueryOptions } from '~/lib/queries/organization';
import { TeamSettingsPanel } from '~/features/settings/TeamSettingsPanel';

// Settings → Team. The members + invites list defines the page, so await it on the
// server (first paint shows the real table, not a skeleton); a client navigation
// prefetches it non-blocking. Org/role + session are warmed by `_protected`.
export const Route = createFileRoute('/_protected/settings/team')({
  loader: ({ context }) => ensureRouteData(context.queryClient, teamQueryOptions()),
  component: SettingsTeamRoute,
});

function SettingsTeamRoute(): ReactNode {
  return <TeamSettingsPanel />;
}
